"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRequest = exports.createUseRequest = void 0;

var _react = require("react");

var _utils = require("@kzui/utils");

var _tools = require("./tools");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * 请求hook
 * 可用于简单的get接口获取数据(无分页)
 * @param {RequestParams} requestParams { url, payload } or url
 * @param dep useEffect dep
 * 
 * ```js
 * 
 * const { data = { items: {} } } = useRequest<{ items: Group }>(GOODS_GROUP_LIST)
 * 
 * const { data = { items: {} } } = 
 *    useRequest<{ items: Group }>({ url: GOODS_GROUP_LIST }, {}, [])
 * ```
 */


var request = new _utils.Request(function (config) {
  // 按照 fetch 发起请求
  return fetch(config.url, {
    method: config.method,
    body: config.method === 'GET' || config.method === 'DELETE' || config.method === undefined ? undefined : config.payload,
    headers: config.headers
  }).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.json();
  });
}, {
  baseUrl: ''
}, {
  request: [function (config) {
    // 在请求发起之前，处理config
    var _config = {};
    _config = _objectSpread({}, config);

    if (config.method === 'POST' || config.method === 'PUT') {
      var _config$headers;

      if (((_config$headers = config.headers) === null || _config$headers === void 0 ? void 0 : _config$headers['content-type']) === 'application/x-www-form-urlencoded') {
        _config['payload'] = (0, _tools.encodeQueryString)(config.payload);
      } else {
        _config['payload'] = JSON.stringify(config.payload);
      }
    }

    return _config;
  }],
  response: [[function (response) {
    return response;
  }, function (error) {
    // 统一对异常处理 *默认: 如果 status 不在 [100, 300) 之间就走这里 
    return Promise.reject(error);
  }]]
});

var createUseRequest = function createUseRequest(request) {
  function useRequest(requestConfigOrUrlOrConfigGen, options, dep) {
    var payload = {};
    var url = '';
    var headers = {};
    var method = 'GET';
    var shouldExecute = true;

    if ((options === null || options === void 0 ? void 0 : options.shouldExecute) !== undefined) {
      shouldExecute = options.shouldExecute;
    }

    if (typeof requestConfigOrUrlOrConfigGen === 'string') {
      url = requestConfigOrUrlOrConfigGen;
    } else if (_typeof(requestConfigOrUrlOrConfigGen) === 'object') {
      url = requestConfigOrUrlOrConfigGen.url || url;
      payload = requestConfigOrUrlOrConfigGen.payload || payload;
      headers = requestConfigOrUrlOrConfigGen.headers || headers;
      method = requestConfigOrUrlOrConfigGen.method || method;
    }

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        loading = _useState2[0],
        setLoading = _useState2[1];

    var _useState3 = (0, _react.useState)(),
        _useState4 = _slicedToArray(_useState3, 2),
        data = _useState4[0],
        setData = _useState4[1];

    var _useState5 = (0, _react.useState)(),
        _useState6 = _slicedToArray(_useState5, 2),
        error = _useState6[0],
        setError = _useState6[1]; // todo can pass params


    function run(values) {
      var params = {
        url: url,
        payload: payload,
        headers: headers,
        method: method
      };

      if (typeof requestConfigOrUrlOrConfigGen === 'function') {
        params = _objectSpread(_objectSpread({}, params), requestConfigOrUrlOrConfigGen(values));
      }

      setLoading(true);
      return request(params).then(function (_data) {
        setData(_data);
        setLoading(false);
        return _data;
      })["catch"](function (e) {
        setError(e);
        setLoading(false);
        throw e;
      });
    }

    (0, _react.useEffect)(function () {
      console.log(shouldExecute, 'effect');

      if (shouldExecute) {
        run();
      }
    }, [].concat(_toConsumableArray(dep || []), [shouldExecute]));
    return {
      data: data,
      error: error,
      loading: loading,
      run: run,
      setData: setData
    };
  }

  return useRequest;
}; // 默认提供 request 为 fetch 的 useRequest


exports.createUseRequest = createUseRequest;
var useRequest = createUseRequest(request.run.bind(request));
exports.useRequest = useRequest;